import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isMobile from 'ismobilejs';

import {
    updateSMSAttributes,
    resetSMSAttributes,
    linkSMSChannel,
    unlinkSMSChannel,
    pingSMSChannel,
} from '../../actions/integrations';
import { ReactTelephoneInput } from '../../lib/react-telephone-input';
import CircularLoading from '../CircularLoading';

export class SMSChannelContentComponent extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        linkColor: PropTypes.string,
        _id: PropTypes.string.isRequired,
        phoneNumber: PropTypes.string,
        originator: PropTypes.string,
        linkState: PropTypes.oneOf(['unlinked', 'pending', 'linked']),
        text: PropTypes.object.isRequired,
        channelState: PropTypes.object.isRequired,
        type: PropTypes.oneOf(['twilio', 'messagebird']),
    };

    linkPhoneNumber = () => {
        const {
            dispatch,
            channelState: { appUserNumber },
            type,
            _id,
        } = this.props;

        dispatch(
            updateSMSAttributes(
                {
                    isWorking: true,
                },
                type,
            ),
        );

        dispatch(
            linkSMSChannel({
                type,
                phoneNumber: appUserNumber.replace(/[()\-\s]/g, ''),
                integrationId: _id,
            }),
        );
    };

    unlinkChannel = () => {
        const { dispatch, type } = this.props;
        dispatch(unlinkSMSChannel(type));
    };

    handleInputChange = (telNumber) => {
        const { dispatch, type } = this.props;
        dispatch(
            updateSMSAttributes(
                {
                    appUserNumber: telNumber,
                },
                type,
            ),
        );
    };

    onStartTexting = () => {
        const { dispatch, type } = this.props;
        dispatch(
            updateSMSAttributes(
                {
                    linkState: 'linked',
                },
                type,
            ),
        );
    };

    onSendText = () => {
        const { dispatch, type } = this.props;
        dispatch(pingSMSChannel(type));
    };

    onNumberValid = () => {
        const { dispatch, type } = this.props;
        dispatch(
            updateSMSAttributes(
                {
                    appUserNumberValid: true,
                    hasError: false,
                },
                type,
            ),
        );
    };

    onNumberInvalid = () => {
        const { dispatch, type } = this.props;
        dispatch(
            updateSMSAttributes(
                {
                    appUserNumberValid: false,
                },
                type,
            ),
        );
    };

    componentWillUnmount() {
        const { dispatch, type } = this.props;
        dispatch(resetSMSAttributes(type));
    }

    getLinkedComponent() {
        const { text, originator, phoneNumber, channelState, linkColor } = this.props;

        const { appUserNumber } = channelState;
        const { smsStartTexting, smsChangeNumber, smsSendText } = text;

        const linkStyle = {
            color: 'white',
        };
        const sendTextUrl = `sms://${phoneNumber || originator}`;
        const iconStyle = linkColor ? { color: `#${linkColor}` } : {};

        const linkedComponentButton = isMobile().phone ? (
            <a
                href={sendTextUrl}
                className="btn btn-primary sms-linking"
                onClick={this.onStartTexting}
                style={linkStyle}
            >
                {smsStartTexting}
            </a>
        ) : (
            <button className="btn btn-primary sms-linking" onClick={this.onSendText}>
                {smsSendText}
            </button>
        );

        return (
            <div>
                <div className="sms-linking linked-state">
                    <i className="fa fa-phone" style={iconStyle}></i>
                    <span className="phone-number">{appUserNumber}</span>
                    <a onClick={this.unlinkChannel}>{smsChangeNumber}</a>
                </div>
                {linkedComponentButton}
            </div>
        );
    }

    getPendingComponent() {
        const { text, channelState, linkColor } = this.props;
        const { smsLinkPending, smsCancel } = text;
        const { appUserNumber } = channelState;

        const iconStyle = linkColor ? { color: `#${linkColor}` } : {};

        return (
            <div className="sms-linking pending-state">
                <i className="fa fa-phone" style={iconStyle}></i>
                <span className="phone-number">
                    {appUserNumber} - {smsLinkPending}
                </span>
                <a onClick={this.unlinkChannel}>{smsCancel}</a>
            </div>
        );
    }

    getUnlinkedComponent() {
        const { text, channelState } = this.props;
        const { smsInvalidNumberError, smsContinue } = text;
        const { appUserNumber, appUserNumberValid, errorMessage, hasError, isWorking } = channelState;

        const invalidNumberMessage = appUserNumber && !appUserNumberValid ? smsInvalidNumberError : '';

        const warningMessage =
            invalidNumberMessage || hasError ? (
                <div className="warning-message">{invalidNumberMessage ? invalidNumberMessage : errorMessage}</div>
            ) : (
                ''
            );
        const linkButton =
            !isWorking && appUserNumberValid ? (
                <button className="btn btn-primary" onClick={this.linkPhoneNumber}>
                    {smsContinue}
                </button>
            ) : (
                ''
            );

        const onEnterKeyPress = appUserNumberValid
            ? this.linkPhoneNumber
            : () => {
                  // Do nothing on enter if the number is invalid
              };

        const spinner = isWorking ? (
            <div style={{ marginTop: '20px' }}>
                <CircularLoading />
            </div>
        ) : null;

        return (
            <div className="sms-linking unlinked-state">
                <ReactTelephoneInput
                    ref={(c) => (this._telInput = c)}
                    defaultCountry="us"
                    isValid={false}
                    onChange={this.handleInputChange}
                    onValid={this.onNumberValid}
                    onInvalid={this.onNumberInvalid}
                    preferredCountries={['us', 'ca']}
                    onEnterKeyPress={onEnterKeyPress}
                    onBlur={this.handleInputBlur}
                />
                {warningMessage}
                {linkButton}
                {spinner}
            </div>
        );
    }

    render() {
        const { channelState } = this.props;
        const { linkState } = channelState;

        if (linkState === 'pending') {
            return this.getPendingComponent();
        } else if (linkState === 'linked') {
            return this.getLinkedComponent();
        } else {
            return this.getUnlinkedComponent();
        }
    }
}

export default connect(
    ({ config, ui: { text } }) => {
        return {
            linkColor: config.colors.linkColor,
            text: {
                smsInvalidNumberError: text.smsInvalidNumberError,
                smsLinkPending: text.smsLinkPending,
                smsStartTexting: text.smsStartTexting,
                smsCancel: text.smsCancel,
                smsChangeNumber: text.smsChangeNumber,
                smsSendText: text.smsSendText,
                smsContinue: text.smsContinue,
            },
        };
    },
    undefined,
    undefined,
    { forwardRef: true },
)(SMSChannelContentComponent);
